module.exports = __webpack_public_path__ + "img/tidak_dicover.9034cd05.svg";